import { takeEvery } from 'redux-saga/effects';

import * as basketActions from 'store/modules/basket';
import { completeStep } from './utils';

export default function* listenCompleteStep() {
  yield takeEvery(basketActions.completeStep.toString(), completeStep);
}
